<template>
  <li
    v-if="locales?.length > 1"
    class="dk-navbar__language-switcher dk-navbar__nav-item"
  >
    <div
      class="dk-dropdown dk-dropdown--primary dk-dropdown--right"
      :class="{ 'dk-dropdown--expanded': isExpanded }"
    >
      <button
        class="dk-dropdown__toggle h-full items-center justify-center"
        @click="$emit('toggle')"
      >
        {{ getLanguageFormatted() }}
      </button>
      <ul class="dk-dropdown__menu p-small">
        <li
          v-for="(locale, index) in locales"
          :key="`locale-${index}`"
          :class="{
            'dk-dropdown__menu-item--active': currentLocale === locale,
          }"
          class="dk-dropdown__menu-item flex"
          @click="$emit('switchLang', locale)"
        >
          <span class="mr-8 w-4/5 text-right">{{
            $t(`languages.${locale}`)
          }}</span>
          <span class="w-1/5">{{
            getLanguageFormatted(locale).toUpperCase()
          }}</span>
        </li>
      </ul>
    </div>
  </li>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { getLanguageFromLocale, getSupportedLocales } from '@/helpers/i18n';

@Component({
  emits: ['toggle', 'switchLang'],
})
export default class NavbarLanguageSwitcher extends Vue {
  @Prop({ default: false }) isExpanded!: boolean;

  get locales(): string[] {
    return getSupportedLocales();
  }

  get currentLocale(): string {
    return this.$i18n.locale;
  }

  getLanguageFormatted(locale: string = this.$i18n.locale): string {
    return (getLanguageFromLocale(locale) || '').toUpperCase();
  }
}
</script>
